import { useEffect } from 'react';
import isElectron from 'is-electron';

import { retryGeoLocation } from 'flow/actions/phone-actions';
import { selectAppFocus } from 'flow/selectors/app-selectors';
import {
    GEO_RETRY_INTERVAL_MS,
    GeoLocationPermission,
    GeoLocationPermissionType,
} from 'flow/utils/geolocation-utils';
import { useAppDispatch, useAppSelector } from './useRedux';

const useGeoLocationRetry = (permission: GeoLocationPermissionType | null) => {
    const dispatch = useAppDispatch();
    const focus = useAppSelector(selectAppFocus);
    const canRetrySilently =
        isElectron() || permission === GeoLocationPermission.GRANTED;

    useEffect(() => {
        if (!canRetrySilently) {
            return undefined;
        }

        if (focus) {
            dispatch(retryGeoLocation());
        }

        const intervalId = setInterval(
            () => dispatch(retryGeoLocation()),
            GEO_RETRY_INTERVAL_MS,
        );

        return () => clearInterval(intervalId);
    }, [dispatch, focus, canRetrySilently]);
};

export default useGeoLocationRetry;
